//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import manualSearch from '@/components/manual-search';
export default {
  name: "source-list",
  components: {manualSearch},
  data() {
    return {
      value: '',
      joinStatus:'100',
      title:'寻源项目',
      wrapperHeight: 0,
      allLoaded: false,
      page: 0,
      sourcingList: [],
      purorgList: [],
      classList: [],
      statusList: [{name:'全部',code:'100',selected:true},{name:'未参与',code:'101'},{name:'已报名',code: '102'},{name:'待报价',code:'104'},{name:'已报价',code:'105'},{name:'中标',code:'107'},{name:'被淘汰',code:'108'},{name:'已放弃',code:'109'}],
      sourceClass: '',
      stageStatuList:[{name:'全部',code:null},{name:'未开始',code:'notStarted'},{name:'进行中',code:'going'},{name:'已结束',code:"'finish','awarded'"},{name:'暂停',code:"pause"}],
      sourceWayList: [
        {name: '全部', code: '', selected: true},
        {name: '公开参与', code: 'PUBLIC'},
        {name: '邀请参与', code: 'INVITATION'},
      ],
      typeCode: null,
      purorgCode: '',
      codeSort: 'DESC',
      rules: [],
      pageRules: {
        direction: "DESC",
        fromClientType: "h5",
        number: 0,
        property: "createdDate",
        size: 10,
        specialConditions: [],
        workflowSearchBean: {}
      }
    }
  },
  methods: {
    backLast(){
      this.$router.go(-1);
    },
    getRules(e) {
      if(e.length){
        e.forEach(data=>{
          if (this.rules.length) {
            this.rules = this.rules.filter(val => val.field !== data.name)
          }
          if (data.code) {
            this.rules.push({field: data.name, option: data.option, values: [data.code]})
          }
        });
      }else{
        //重置菜单
        this.rules=[]
      }
      this.getSourcingList()
    },
    searchSourcing(searchData) {
      if (this.rules.length) {
        this.rules = this.rules.filter(val => val.field !== 'sourceNum-sourceProject-executor.name-leader');
      }
      this.rules.push({
        field: "sourceNum-sourceProject-executor.name-leader",
        option: "LIKE_ANYWHERE",
        values: [searchData.key]
      });
      this.getSourcingList();
    },
    clear() {
      this.rules = this.rules.filter(val => val.field !== 'sourceNum-sourceProject-executor.name-leader');
      this.getSourcingList()
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top;
    },
    initClassList() {
      this.classList = [];
      this.$get('api/sourceType/all').then(info => {
        for (let i = 0; i < info.length; i++) {
          let obj = {};
          obj.name = info[i].typeName;
          obj.code = info[i].typeCode;
          this.classList.push(obj);
        }
        this.classList.unshift({name: '全部', code: null, selected: true});
      })
    },
    joinStatusClick(item) {
      if (this.rules.length) {
        this.rules = this.rules.filter(val => val.field !== 'sourcingType.typeCode')
      }
      if (item.value) {
        this.rules.push({field: "joinStatus", option: "IN", values: [item.value]})
      }
      this.page = 0;
      this.getSourcingList();
    },
    stageStatuChange(e) {
      if (this.rules.length) {
        this.rules = this.rules.filter(val => val.field !== 'status')
      }
      if (e.code) {
        let code = e.code;
        if(e.code !== "'finish','awarded'"){
          code = `'${e.code}'`;
        }
        this.rules.push({field:"status", option: "IN", values: [code]})
      }
      this.getSourcingList();
    },
    purorgOnChange(e) {
      if (this.rules.length) {
        this.rules = this.rules.filter(val => val.field !== 'purorg.purorgName')
      }
      if (e.code) {
        this.rules.push({
          field: "purorg.purorgName",
          option: "IN",
          values: [e.name]
        })
      }
      this.getSourcingList();
    },
    sourceWayOnChange(e){
      if (this.rules.length) {
        this.rules = this.rules.filter(val => val.field !== 'sourceWay')
      }
      if (e.code) {
        this.rules.push({
          field: "sourceWay",
          option: "IN",
          values: [e.code]
        })
      }
      this.getSourcingList();
    },
    changeSort() {
      if (this.codeSort === 'DESC') {
        this.codeSort = 'ASC';
      } else {
        this.codeSort = 'DESC';
      }
      this.getSourcingList();
    },
    loadTop() {
      this.pageRules.number = 0;
      let rules = [{field:"joinStatus", option: "IN", values: [this.joinStatus]}];
      if (this.rules.length) {
        this.pageRules.rules = [].concat(rules, this.rules)
      } else {
        this.pageRules.rules = rules;
      }
      this.$post('api/sourceStageLog/query/page', this.pageRules).then((list) => {
        this.sourcingList = list.content;
        this.pageRules.rules = [];
        this.$loadingHide();
        this.$refs.loadmore.onTopLoaded();
      }).catch((error) => {
        this.$loadingHide();
        this.$refs.loadmore.onTopLoaded();
      });
    },
    loadBottom() {
      this.pageRules.number++;
      let rules = [{field:"joinStatus", option: "IN", values: [this.joinStatus]}];
      if (this.rules.length) {
        this.pageRules.rules = [].concat(rules, this.rules)
      } else {
        this.pageRules.rules = rules;
      }
      this.$post('api/sourceStageLog/query/page', this.pageRules).then((list) => {
        this.sourcingList = this.sourcingList.concat(list.content);
        this.$loadingHide();
        this.pageRules.rules = [];
        this.$refs.loadmore.onBottomLoaded();
      }).catch((error) => {
        this.$loadingHide();
      });

    },
    getSourcingList() {
      this.pageRules.number = 0;
      this.$loadingShow();
      let rules = [{field:"joinStatus", option: "IN", values: [this.joinStatus]}];
      if (this.rules.length) {
        this.pageRules.rules = [].concat(rules, this.rules)
      } else {
        this.pageRules.rules = rules;
      }
      this.$post('api/sourceStageLog/query/page', this.pageRules).then((list) => {
        this.$nextTick(() => {
          this.sourcingList = list.content;
        });
        this.pageRules.rules = [];
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    //获取全部采购组织列表
    getPurorgList() {
      this.$loadingShow();
      this.$get('api/purorg').then((data) => {
        let list = [{code: null, name: '全部'}];
        if (data && data.length) {
          data.forEach(val => {
            if(val.enabled){
              list.push({name: val.purorgName, code: val.purorgCode});
            }
          })
        }
        this.$nextTick(() => {
          this.purorgList = list;
        });
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    /**
     * 获取阶段状态
     * */
    //跳转到详情页
    goSourceDetail(source) {
      this.$router.push(`/sources-sup/${source.id}`);
    },
    //  初始加载
    initGetSourcingData() {
      this.getSourcingList();
    }
  },
  mounted() {
    this.init();
    this.initClassList();
  },
  created() {
    this.joinStatus = this.$route.params.status;
    this.initGetSourcingData();
    this.getPurorgList();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-sup/source-list.vue